import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSkypeComponent } from './simple-icons-skype.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSkypeComponent ],
    exports:      [ SimpleIconsSkypeComponent ],
    bootstrap:    []
})
export class SimpleIconsSkypeModule {}
